// Validation of accreditation mappings on the data instead of on the form (#830), so an invalid mapping in a closed
// accordion item can be marked and opened. The rules follow the fields in sdb-accreditation-info.js.

const POINTS_STEP = 0.5;

const isEmpty = (value) => value === undefined || value === null || String(value) === '';

// The date pickers compare whole local days.
const toLocalDay = (value) => {
    const date = new Date(value);

    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
};

const isNumber = (value) => !isEmpty(value) && Number.isFinite(Number(value));

// The number field passes its step to the native input, which rejects a value that is not a multiple of it.
const isMultipleOf = (value, step) => {
    const steps = Number(value) / step;

    return Math.abs(steps - Math.round(steps)) < 1e-9;
};

/**
 * The invalid fields of one mapping, empty when it is valid.
 *
 * @param {object} mapping
 * @returns {string[]} field names: organization, period, peCourseId, peModuleId, points
 */
export const validateAccreditationMapping = (mapping) => {
    if (!mapping) { return []; }

    const data = mapping.data ?? {};
    const errors = [];

    if (isEmpty(mapping.organizationKey)) { errors.push('organization'); }

    if (!isEmpty(mapping.validFrom) && !isEmpty(mapping.validTill) && toLocalDay(mapping.validFrom) > toLocalDay(mapping.validTill)) {
        errors.push('period');
    }

    if (!isNumber(data.peCourseId)) { errors.push('peCourseId'); }

    if (!isEmpty(data.peModuleId) && !isNumber(data.peModuleId)) { errors.push('peModuleId'); }

    if (!isEmpty(mapping.points) && !(isNumber(mapping.points) && Number(mapping.points) >= 0 && isMultipleOf(mapping.points, POINTS_STEP))) {
        errors.push('points');
    }

    return errors;
};

/**
 * The indexes of the invalid mappings, in list order.
 *
 * @param {object[]} mappings
 * @returns {number[]}
 */
export const getInvalidMappingIndexes = (mappings) =>
    (mappings ?? []).reduce((indexes, mapping, index) => {
        if (validateAccreditationMapping(mapping).length > 0) { indexes.push(index); }

        return indexes;
    }, []);
